import { render, staticRenderFns } from "./Ibm.vue?vue&type=template&id=2f418d26&scoped=true"
import script from "./Ibm.vue?vue&type=script&lang=js"
export * from "./Ibm.vue?vue&type=script&lang=js"
import style0 from "./Ibm.vue?vue&type=style&index=0&id=2f418d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f418d26",
  null
  
)

export default component.exports